module.exports = __webpack_public_path__ + "img/ic_arrow_back.f4ab5499.svg";